import React,{useState,useLayoutEffect } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/RTCC/button';
import '../resources/css/login/login.css';

export const MemberShipOutsideHoursCheck = (props) => {

    const {
        state,
        setOutsideHoursFlg,
        setMenuTitle
    } = props;

    const outsideHoursFlg = state.outsideHoursFlg;
    const menuTitle = state.menuTitle;
    const store = useStore();
    const envParam = store.getState().envParam;
    const [outsideHoursStartTime, setOutsideHoursStartTime] = useState("");
    const [outsideHoursEndTime, setOutsideHoursEndTime] = useState("");

    const onClickSetDisplayFlgSwitch = () => {
        setOutsideHoursFlg(!outsideHoursFlg);
        setMenuTitle("");
    };

    //画面読み込み時に1度だけしか実行させない
    useLayoutEffect(() => {
        let startHour = "";
        let startMinute = "";
        let endHour = "";
        let endMinute = "";
        if (envParam?.open?.length && envParam?.close?.length) {
            if (envParam.open.length == 3) {
                startHour = envParam.open.slice(0, 1);
                startMinute = envParam.open.slice(1);
            } else {
                startHour = envParam.open.slice(0, 2);
                startMinute = envParam.open.slice(2);
            }
            setOutsideHoursStartTime(startHour + ":" + startMinute)
            if (envParam.close.length == 3) {
                endHour = envParam.close.slice(0, 1);
                endMinute = envParam.close.slice(1);
            } else {
                endHour = envParam.close.slice(0, 2);
                endMinute = envParam.close.slice(2);
            }
            setOutsideHoursEndTime(endHour + ":" + endMinute);
        }
    }, []);
    
    return (
        <div>
            {outsideHoursFlg ?
            <div className='modalBody'>
                <div className='modalContent'>
                    <div className='modalArea'>
                        <div>
                            <div className='modalOutSide'>
                                システムメンテナンスのため<br/>{outsideHoursStartTime + "~" + outsideHoursEndTime}は{menuTitle}予約をご利用できません。
                            </div>
                            <div className='modalBtnArea'>
                                <Button
                                    onClick={onClickSetDisplayFlgSwitch}
                                    buttonText={"閉じる"}
                                    className="logoutBtn"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : null
            }
        </div>
    )
}